import React, { useContext, useEffect, useState } from 'react'
import { Spin } from 'antd'
import { get, put } from '../../Common/api'
import EventPanel from './EventPanel'
import { useParams } from 'react-router'
import EventFilter from './EventFilter'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import EventDetail from './EventDetail'
import EventListXS from './EventListXS'
import EventListXL from './EventListXL'
import GlobalContext from '../GlobalContext'
import dayjs from 'dayjs'

export default function EventsPage () {
  const { events, updateEvents, filters } = useContext(GlobalContext)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState({})
  const { id } = useParams()
  const { notificationApi } = useContext(GlobalContext)
  const [currentFilter, setCurrentFilter] = useState(filters.find((filter) => filter.default))

  const screens = useBreakpoint()

  useEffect(() => {
    if (id) { showEvent(id) }
  }, [])

  const updateEvent = (updatedEvent) => {
    if (updatedEvent?.id) {
      updateEvents([updatedEvent])
      if (selectedEvent.id === updatedEvent.id) {
        setSelectedEvent({ ...selectedEvent, ...updatedEvent })
      }
    }
  }

  const updateEventRequest = async (event) => {
    setLoading(true)
    await put({
      url: `admin/events/${event.id}`,
      params: event,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (newEvent) => {
        const response = { ...newEvent.event, content: newEvent.content_trix_html, comments: event.comments }
        setSelectedEvent(response)
        updateEvents([response])
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const getComments = async (id) => {
    setLoading(true)
    await get({
      url: `admin/events/${id}`,
      params: {},
      onSuccess: (res) => {
        setLoading(false)
        const event = { ...res.event, comments: res.comments, content: res.event.content_trix_html }
        setSelectedEvent(event)
        updateEvents([event])
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const showEvent = (id) => {
    getComments(id)
    setOpen(true)
  }

  const resolveEvent = async (event) => {
    setLoading(true)
    await put({
      url: `admin/events/${event.id}`,
      params: { ...event, resolved: !event.resolved },
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (res) => {
        setLoading(false)
        event = { ...res.event, content: res.event.content_trix_html }
        updateEvent(event)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const onClose = () => {
    setSelectedEvent({})
    setOpen(false)
  }

  const addComment = (comments) => (comment) => {
    setSelectedEvent({
      ...selectedEvent,
      comment_count: selectedEvent.comment_count + 1,
      comments: [...comments, comment]
    })
  }

  const periodFilter = (value) => {
    if (value === 'day') {
      return dayjs().startOf('day')
    } else if (value === 'week') {
      return dayjs().startOf('day').subtract(7, 'day')
    } else {
      return dayjs('2022-01-01')
    }
  }

  const tagFilter = (filter, event) => {
    let notMatching = true
    event.tags.forEach((tag) => {
      if (tag.id === filter.value || tag.family.id === filter.value || tag.family.business_area.id === filter.value) {
        notMatching = false
      }
    })
    return notMatching
  }

  const filteredEvents = events.sort((a, b) => dayjs(b.created_at).diff(dayjs(a.created_at))).filter((event) => {
    if (currentFilter) {
      let notMatching = false
      currentFilter.filters.forEach((filter) => {
        if (filter.value.length > 0) {
          let condition = false
          if (filter.name === 'resolved') {
            condition = (filter.value === 'true') !== event[filter.name]
          } else if (['tag_id', 'family_id', 'business_area_id'].includes(filter.name)) {
            condition = tagFilter(filter, event)
          } else if (filter.name === 'period') {
            condition = dayjs(event.created_at).diff(periodFilter(filter.value)) < 0
          } else {
            condition = filter.value !== event[filter.name]
          }
          if (condition) {
            notMatching = true
          }
        }
      })
      return !notMatching
    }
    return false
  })

  return (
    <Spin spinning={loading} style={{ minHeight: '87vh' }}>
      {!screens.xs && currentFilter &&
        <>
          <EventFilter setLoading={setLoading} currentFilter={currentFilter} setCurrentFilter={setCurrentFilter} />
          <EventListXL events={filteredEvents} showEvent={showEvent} resolveEvent={resolveEvent} updateEvent={updateEvent} />
          <EventPanel event={selectedEvent} open={open} onClose={onClose} updateEventRequest={updateEventRequest} updateEvent={updateEvent} setSelectedEvent={setSelectedEvent} addComment={addComment} />
        </>
      }
      {screens.xs && !id && currentFilter && <EventListXS events={filteredEvents} showEvent={showEvent} mobile={true} updateEvent={updateEvent} />}
      {screens.xs && id && currentFilter && <EventDetail event={selectedEvent} updateEventRequest={updateEventRequest} updateEvent={updateEvent} showEvent={() => showEvent(id)} addComment={addComment} />}
    </Spin>
  )
}
